import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axiosInstance from '../../utils/axiosSetup.js';
import DeleteComponent from '../../action/delete.jsx';
import moment from 'moment';
import AddHoliday from "./sections/add";
import EditHoliday from './sections/edit';


const Holidays = () => {
    const [roleId, setRoleId] = useState(null);
    const [holidays, setHolidays] = useState([]);
    const [holidayId, setHolidayId] = useState(null);

    useEffect(() => {
        fetchHolidays();
    }, []);

    const fetchHolidays = async () => {
        try {
            const response = await axiosInstance.get(`${process.env.REACT_APP_API_URL}/holidays`);
            setRoleId(response.data.data.roleId);
            setHolidays(response.data.data.holidays);
        } catch (error) {
            console.error("Error fetching holidays", error);
            setRoleId(null);
            setHolidays([]);
        }
    };
      
    return (
        <>    
            <div className="content container-fluid">
                <div className="page-header">
                    <div className="row align-items-center">
                        <div className="col">
                            <h3 className="page-title">Holidays {new Date().getFullYear()}</h3>
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/dashboard">Dashboard</Link></li>
                                <li className="breadcrumb-item active">Holidays</li>
                            </ul>
                        </div>
                        {roleId === 1 &&
                            <div className="col-auto float-end ms-auto">
                                <Link to="#" className="btn add-btn" data-bs-toggle="modal" data-bs-target="#add_holiday">
                                    <i className="fa-solid fa-plus"></i> Add Holiday</Link>
                            </div>
                        }
                    </div>
                </div>

                <div className="card">
                    <div className="card-body">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="table-responsive">
                                    <table className="table table-striped custom-table">
                                        <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>Holiday Name</th>
                                                <th>Holiday Date</th>
                                                {roleId === 1 &&
                                                    <th className="text-end">Action</th>
                                                }
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                holidays.length > 0 ? (
                                                    holidays.map((holiday, index) => (
                                                        <tr key={holiday.id}>
                                                            <td>{++index || ''}</td>
                                                            <td>{holiday.name || ''}</td>
                                                            <td>{holiday.date ? moment(holiday.date, "YYYY-MM-DD HH:mm:ss").format("dddd, MMMM Do YYYY") : ''}</td>
                                                            
                                                            {roleId === 1 && 
                                                                <td className="text-end">
                                                                    {moment(holiday.date, "YYYY-MM-DD HH:mm:ss").isAfter(moment()) &&
                                                                        <div className="dropdown dropdown-action">
                                                                            <Link to="#" className="action-icon dropdown-toggle"
                                                                                data-bs-toggle="dropdown" aria-expanded="false"
                                                                                    onClick={() => setHolidayId(`${holiday.id}`)}>
                                                                                    <i className="material-icons">more_vert</i></Link>
                                                                            <div className="dropdown-menu dropdown-menu-right">
                                                                                <Link className="dropdown-item" to="#" data-bs-toggle="modal"
                                                                                    data-bs-target={`#edit_holiday_${holiday.id}`}>
                                                                                        <i className="fa-solid fa-pencil m-r-5"></i> Edit</Link>
                                                                                    <DeleteComponent 
                                                                                        url = "holidays"
                                                                                        id = {holiday.id}
                                                                                        fetchData={fetchHolidays} />
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                </td>
                                                            }
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan={roleId === 1 ? '4' : '3'}>No records found</td>
                                                    </tr>
                                                )                                          
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <AddHoliday list={fetchHolidays}/>
            <EditHoliday list={fetchHolidays} holidayId={holidayId} />
        </>
    );
}

export default Holidays

